module.exports = require('./helpers/bundle-url').getBundleURL('hKhd1') + "logo.7718c6df.svg";